import { GetValue } from './GetValue';

export class GetValueOrDefaults extends GetValue {
    private executeSuper = false;

    execute<T>(params: GetValue.Params<T>): any | undefined {
        if (this.executeSuper) {
            // Ensure GetValue calls to this.execute() do not go through the subclass
            return super.execute(params);
        }

        this.executeSuper = true;
        let value = super.execute(params);
        this.executeSuper = false;
        if (!this.isDefined(value) && params.from) {
            const paramsWithPaths: GetValue.ParamsWithPaths<T> = {
                from: params.from,
                paths: []
            };

            if (this.hasPath(params)) {
                paramsWithPaths.paths.push(...this.addDefaultsToPath(params.path));
            }

            if (this.hasPaths(params)) {
                params.paths.forEach((path) => {
                    paramsWithPaths.paths.push(...this.addDefaultsToPath(path));
                });
            }

            this.executeSuper = true;
            value = super.execute(paramsWithPaths);
            this.executeSuper = false;
        }

        return value;
    }

    private addDefaultsToPath(path: string): string[] {
        return path.split('.').map((part, index, array) => {
            array = array.slice();
            array.splice(index, 0, 'defaults');
            return array.join('.');
        });
    }
}
